'use client';

import {
  EncountersActionTypes,
  EncountersView,
} from 'src/context/reducers/encountersReducer';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { Drawer, EmptyState } from 'src/components';
import { useEncounters } from 'src/context/providers/EncountersProvider';
import React from 'react';
import { faWarning, faXmark } from '@fortawesome/pro-solid-svg-icons';
import { CreateVolumeType } from '../CreateVolumeType';
import { useDrawer } from 'src/hooks/drawers/useDrawer';
import { IconButton } from 'src/components/PulseUI/IconButton';

const viewComponents: { [key in EncountersView]?: React.ComponentType<any> } = {
  [EncountersView.VOLUME_BILLING]: CreateVolumeType,
  // Add future views here:
  // [EncountersView.ANOTHER_VIEW]: AnotherViewComponent,
};

interface EncountersDrawerProps {
  hideEncounterType?: boolean;
  onSuccess?: (filterSet: any) => void;
}

const EncountersDrawer = ({ hideEncounterType = false, onSuccess }: EncountersDrawerProps) => {
  const { state, dispatch } = useEncounters();
  const { isDrawerOpen, closeDrawer } = useDrawer();

  const handleCloseDrawer = () => {
    dispatch({
      type: EncountersActionTypes.SET_VIEW,
      payload: { view: EncountersView.VOLUME_BILLING },
    });
    closeDrawer('encountersDrawer');
  };

  const CurrentViewComponent = viewComponents[state.view as EncountersView];

  return (
    <Drawer
      isOpen={isDrawerOpen('encountersDrawer')}
      onClose={handleCloseDrawer}
      hideBackdrop
      size="base2"
      data-testid={`encounters-drawer-${state.view}`}
      anchor="right"
      variant="temporary"
    >
      {CurrentViewComponent ? (
        <CurrentViewComponent hideEncounterType={hideEncounterType} onSuccess={onSuccess} />
      ) : (
        <>
          <Drawer.Header className="bg-sky-100 text-primary border-b-0">
            <div className="flex items-center justify-between w-full">
              <div className="flex items-center gap-2">
                <p
                  className="font-bold text-lg"
                  data-testid="encounters-drawer-title"
                >
                  Editing Code Set
                </p>
              </div>
              <div className="flex items-center gap-2">
                <IconButton
                  variant="plain"
                  color="neutral"
                  size="sm"
                  onClick={handleCloseDrawer}
                  icon={faXmark}
                  className="text-primary hover:bg-sky-200"
                  data-testid="encounters-drawer-close-button"
                />
              </div>
            </div>
          </Drawer.Header>
          <EmptyState
            title="Unable to Load View"
            description="There was an issue loading the selected encounter view. Please reload the page."
            icon={
              <Icon
                icon={faWarning}
                className="text-7xl text-neutral-400/80"
                data-testid="empty-state-icon"
              />
            }
          />
        </>
      )}
    </Drawer>
  );
};

export default EncountersDrawer;
